export default __webpack_public_path__ + "static/media/close-button.f8434566.png";